import { HGetKeyEnums } from "@rf-helper/generat-enums-from-keys";
import { object, string, array, InferType, boolean } from "@yup";

export const ActivatePropertySchema = object({
  isProject: boolean().default(false),
  days: string()
    .isNumeric()
    .minValue(1, "La cantidad de días mínima es 1")
    .maxValue(240, "La cantidad de días máxima es 240")
    .default("240")
    .meta({ label: "Días" })
    .required("Días es requerido"),
  actionMode: string()
    .oneOf(["full", "partial", ""], "Acción no válida")
    .default("")
    .meta({ label: "Acción" })
    .when(["isProject"], {
      is: (isProject: boolean) => isProject,
      then: schema => schema.required("Acción es requerida"),
      otherwise: schema => schema
    })
});

export type IActivatePropertySchema = InferType<typeof ActivatePropertySchema>;
export const CActivateProperty = ActivatePropertySchema.getDefault();
export const CActivatePropertyKeys = HGetKeyEnums(CActivateProperty) as {
  [K in keyof typeof CActivateProperty]: K;
};
